export default __webpack_public_path__ + "static/media/chart5.98eea436.png";